import { IComponentWidget } from "@common/models/CMS";
import FeaturedFlights from "@components/FeaturedFlights";
import ManageBookingTabPanel from "@components/home/ManageBookingTabPanel";
import { ReservationTabPanel } from "@pages/home/ReservationTabPanel";
import { FC } from "react";
import Enquiry from "./Enquiry";

interface IComponentWidgetProps {
    dataSource: IComponentWidget;
}

const ComponentWidget: FC<IComponentWidgetProps> = ({ dataSource }) => {

    const renderComponent = () => {
        switch (dataSource.componet) {
            case "TourEnquiry":
                return <Enquiry />;
            case "ReservationTabPanel":
                return <ReservationTabPanel />;
            case "FeaturedFlights":
                return <FeaturedFlights className="m-0" />;
            case "FindReservation":
                return <ManageBookingTabPanel className="p-6" />;
            default:
                break;
        }
    }

    return (
        <div className="component-widget">
            {renderComponent()}
        </div>
    )
}

export default ComponentWidget;